import { ActionIcon } from '@mantine/core';
import { useAuth } from '@sportybot-web/auth/useAuth';
import { Clipboard } from 'lucide-react';

export function CopyTokenButton() {
  const { authClient } = useAuth();

  const handleClick = async () => {
    await navigator.clipboard.writeText(authClient.getAccessToken() ?? '');
  };

  return (
    <ActionIcon disabled={!authClient.isAuthenticated} onClick={handleClick} variant="default">
      <Clipboard size={16} />
    </ActionIcon>
  );
}
